import React, { useCallback, useEffect, useState } from "react";
import { TournamentEntryList } from "@nestcoinco/hyper-api-gateway-api-client";
import { useTranslation } from "react-i18next";

import "./PendingGameEntriesSection.scss";
import PendingGameCard from "../../PendingGameCard/PendingGameCard";
import TooltipButton from "../../TooltipButton/TooltipButton";
import PendingGamesInfoModal from "../../modals/PendingGamesInfoModal/PendingGamesInfoModal";
import { handleGetTournamentPendingEntries } from "../../../../api-clients/tournamentsClient";
import Skeleton from "../../../Skeleton/Skeleton";

function LoadingSkeleton() {
  return (
    <div className="px-3 mb-3">
      <Skeleton height={14} width={144} style={{ marginBottom: 22 }} />
      <div className="d-flex justify-content-between">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i}>
            <Skeleton
              className="mb-2"
              height={100}
              width={100}
              borderRadius={12}
            />
            <Skeleton
              className="mb-1"
              height={11}
              width={83}
              borderRadius={15}
            />
            <Skeleton height={11} width={87} borderRadius={15} />
          </div>
        ))}
      </div>
    </div>
  );
}

function PendingGameEntriesSection() {
  const { t } = useTranslation("dashboard");
  const [isOpen, setIsOpen] = useState(false);
  const [pendingGames, setPendingGames] = useState<TournamentEntryList>();
  const [isLoading, setIsLoading] = useState(true);

  const getPendingGames = useCallback(async () => {
    const games = await handleGetTournamentPendingEntries();
    setPendingGames(games);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    getPendingGames();
  }, [getPendingGames]);

  if (isLoading) return <LoadingSkeleton />;

  if (!pendingGames || pendingGames.records.length === 0) return null;

  return (
    <section
      className={`pending-game-entries-section ${isLoading ? "px-3" : ""}`}
    >
      <div className="heading-container d-flex justify-content-between align-items-center px-3">
        <h2 className="heading">{t("pending_game_entries")}</h2>
        <TooltipButton onClick={() => setIsOpen(true)} />
      </div>
      <div className="d-flex gap-2 px-3 cards-container scrollbar-hidden">
        {pendingGames?.records.map((game) => (
          <PendingGameCard key={game.id} {...game} refetch={getPendingGames} />
        ))}
      </div>

      <PendingGamesInfoModal show={isOpen} onHide={() => setIsOpen(false)} />
    </section>
  );
}

export default PendingGameEntriesSection;
